import { createContext, useContext } from "react";
import { CircleCheck, Heart } from "lucide-react";
import type { SavedItem } from "./terra-boa-data";
import { type BrazilLocation, type BrazilMunicipality, isValidBrazilLocation } from "./terra-boa-locations";
import { savedItemForLocation } from "./terra-boa-saved-locations";

export const LocationFavoritesContext = createContext<{
  items: SavedItem[];
  onSave: (item: SavedItem) => void;
} | null>(null);

export function LocationFavoriteButton({ location, additionalMunicipalities, disabled = false, className = "" }: {
  location: BrazilLocation;
  additionalMunicipalities: BrazilMunicipality[];
  disabled?: boolean;
  className?: string;
}) {
  const favorites = useContext(LocationFavoritesContext);
  if (!favorites || !isValidBrazilLocation(location, additionalMunicipalities)) return null;
  // Um ponto ainda sem nome não deve salvar a cidade por engano.
  if (location.commercialPlaceType && (!location.commercialPlaceId || !location.commercialPlaceName.trim())) return null;
  const item = savedItemForLocation(location);
  if (!item) return null;
  const saved = favorites.items.some((entry) => entry.id === item.id);
  return <button className={`device-location-button location-save-favorite ${className}${saved ? " saved" : ""}`} type="button" disabled={disabled || saved} onClick={() => favorites.onSave(item)}>
    {saved ? <CircleCheck size={17} /> : <Heart size={17} />}
    <span>{saved ? "Localização definida já está nos favoritos" : "Salvar localização definida como favorita"}</span>
  </button>;
}
